<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <bill-control></bill-control>
      <bill-view></bill-view>
    </v-layout>
  </v-container>
</template>


<script>
import BillControl from "@/components/bills/billControl";
import BillView from "@/components/bills/billView";
import Store from "@/store/computed/storeHelpers";

export default {
  components: {
    BillControl,
    BillView
  }
};
</script>

<style>
</style>